<template>
  <div
    :class="[
      'border rounded-lg p-4 h-full max-h-screen flex flex-col transition-all',
      isFocused ? 'ring-2 ring-indigo-500' : ''
    ]"
    ref="container"
  >
    <h4 class="font-semibold mb-2 shrink-0">Criteria</h4>

    <ul class="overflow-y-auto flex-1 min-h-0">
      <!-- ALL -->
      <li
        ref="items"
        @click="$emit('select', { all: true })"
        :class="[
          'cursor-pointer p-1',
          selected?.all ? 'bg-indigo-100' : ''
        ]"
      >
        All criteria
      </li>

      <!-- ACTUAL CRITERIA -->
      <li
        v-for="c in criteria"
        :key="c.criterion_id"
        ref="items"
        @click="$emit('select', c)"
        :class="[
          'cursor-pointer p-1',
          c === selected ? 'bg-indigo-100' : ''
        ]"
      >
        {{ c.criterion.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    criteria: Array,
    selected: Object,
    isFocused: Boolean,
  },
  methods: {
    scrollToSelected() {
      this.$nextTick(() => {
        const items = this.$refs.items;
        if (!items) return;

        let index = 0;

        if (this.selected?.all) {
          index = 0;
        } else {
          index = this.criteria.findIndex(c =>
            c.criterion_id === this.selected?.criterion_id
          ) + 1; // +1 because "All" is item 0
        }

        const el = items[index];
        if (el) {
          el.scrollIntoView({
            block: "nearest",
            inline: "nearest",
            behavior: "smooth",
          });
        }
      });
    }
  },
  watch: {
    selected() {
      this.scrollToSelected();
    }
  }
};
</script>
